import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubOrganisationModel } from '../../models/sub-organisation.model';
import { ITableState, TableResponseModel } from '../../models/table.model';
import { BaseService } from '../../../base.service';

@Component({
	template: ``
})

export class SubOrganisationsTableComponent extends BaseService<SubOrganisationModel>{

	constructor(
		@Inject(HttpClient) http
	) {
		super(http);
	}

	/**
	 *	Find by search string
	 * @param tableState :table state parameters
	 * @returns
	*/
	findSubOrganisations(tableState: ITableState): Observable<TableResponseModel<SubOrganisationModel>> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.SUB_ORGANISATION.SEARCH;
		return this.getItems(url);
	}
}
